import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { switchMap, takeUntil } from 'rxjs/operators';
import { MarineInsuranceFacade, MarineInsuranceState } from '@shared/marine-insurance-shared/services';
import { combineLatest, of, ReplaySubject } from 'rxjs';
import { CompanyModel } from '@data-layer/models/companies';
import { CompaniesService } from '@services/companies.service';
import { MarineInsurancePaymentButtonComponent } from '@shared/marine-insurance-shared/components';

@Component({
  selector: 'app-marine-insurance-quote-updated-pricing-card',
  templateUrl: './marine-insurance-quote-updated-pricing-card.component.html',
  styleUrls: ['./marine-insurance-quote-updated-pricing-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuoteUpdatedPricingCardComponent implements OnInit, OnDestroy {
  @Input() public marineInsurance: MarineInsuranceModel;
  @Input() public pendingBills: PaymentBillItemPendingModel;
  @Input() public isWithMarginTop: boolean;

  public isShowTerms: boolean;

  @ViewChild(MarineInsurancePaymentButtonComponent) private paymentButtonComponentRef: MarineInsurancePaymentButtonComponent;

  private company: CompanyModel;
  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(
    private marineInsuranceFacade: MarineInsuranceFacade,
    private marineInsuranceState: MarineInsuranceState,
    private companiesService: CompaniesService,
    private cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.company = this.companiesService.getCompany();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public showTerms(): void {
    this.isShowTerms = true;
  }

  public hideTerms(): void {
    this.isShowTerms = false;
  }

  public onSuccessPayment(): void {
    this.marineInsuranceFacade
      .getShipment(this.marineInsurance.referenceNumber)
      .pipe(
        switchMap((marineInsurance: MarineInsuranceModel) =>
          combineLatest([
            of(marineInsurance),
            this.marineInsuranceFacade.getPendingBills(this.company.id, [this.marineInsurance.referenceNumber], null, null, false),
          ]),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(([insurance, pendingBills]: [MarineInsuranceModel, PaymentBillItemPendingModel]) => {
        this.marineInsuranceState.saveBillsData(pendingBills);
        this.marineInsuranceState.saveData(insurance, false, false);

        this.cdr.markForCheck();
      });
  }
}
